export default __webpack_public_path__ + "static/wm-1b0957e6d2cdf16a2130d525e9a590a9.gif";